module.exports = [{
      plugin: require('/home/web/origins/pizza-site/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/web/origins/pizza-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
